<script setup>
import { ref, watch, computed } from 'vue'
import { useUserStore } from '@/store/user';
import { useRegionStore } from '@/store/region';
import { useRouter } from 'vue-router'
import BreadCrumbs from '@/components/breadcrumbs/BreadCrumbs.vue'
import ContentSubheaderPage from '@/components/content/ContentSubheaderPage.vue'
import SearchField from '@/components/fields/SearchField.vue'
import PersonalitiesCardMini from '@/components/personalities/PersonalitiesCardMini.vue'

const router = useRouter()
const userStore = useUserStore()
const regionStore = useRegionStore()


const selectedLetter = ref(null)

let letters = computed(()=> userStore.get_letters )
let _personalities = computed(()=> userStore.get_personalities_list )


useRegionStore().getRegions()
const regions = computed(()=> { return regionStore.filter_region})
const region = ref(regionStore.filter_region[0]['code'])
userStore.getPersonalitiesList(regionStore.filter_region[0]['code'], '')
watch(region, (newValue) => {
    userStore.getPersonalitiesList(newValue, search_string.value._value)
    console.log(_personalities.value)
})

const search_string = ref("")
watch(search_string, (newValue) => {
    userStore.getPersonalitiesList(region.value, newValue)
})


const changeLetter = (letter) => {
    try {
        document.getElementById(letter).scrollIntoView({ behavior: 'smooth' })
    } catch {
        return
    }
}

watch(selectedLetter, () => {
    if (selectedLetter.value) {
        document.activeElement.blur() // убираем фокус с select когда выбираем букву
        changeLetter(selectedLetter.value)
        selectedLetter.value = null
    }
})



function clickCard(personality_id){
    // router.push({"path": "personalities/" + personality_id.toString(), "name": "Personalities"})
    router.push({"name": "Personalities", "params": {id: personality_id.toString()}})
}

</script>

<template>
    <div class="container">
        <bread-crumbs/>
        <content-subheader-page
            class="all-personalities-page-content-subheader"
            text="ПЕРСОНАЛИИ"
        />
        <v-container
            :fluid="true"
            class="pa-0"
        >
            <search-field v-model="search_string" class="mt-8" />
            <div class="letters-and-region d-none d-lg-flex">
                <div class="letters">
                    <div 
                        v-for="letter in letters"
                        :key="letter"
                        @click="changeLetter(letter)"
                    >
                        {{ letter }}
                    </div>
                </div>
                <v-select
                    label="Регионы"
                    variant="outlined"
                    :items="regions"
                    v-model="region"
                    item-title= "name"
                    item-value= "code"
                    hide-details
                />
            </div>
            <v-row class="ml-n2 mr-n2 d-lg-none">
                <v-col
                    class="pl-2 pr-2"
                    cols="12"
                >
                    <v-select 
                        id="letterSelect"
                        v-model="selectedLetter"
                        :items="letters"
                        variant="outlined"
                        hide-details
                        label="А-Я"
                    />
                </v-col>
                <v-col
                    class="pl-2 pr-2 mt-5"
                    cols="12"
                >
                    <v-select
                        label="Регионы"
                        variant="outlined"
                        v-model="region"
                        :items="regions"
                        item-title= "name"
                        item-value= "code"
                        hide-details
                    />
                </v-col>
            </v-row>
            <div class="personalities-section">
                <v-row
                    v-for="personality in _personalities"
                    :key="personality.letter" 
                    :id="personality.letter"
                    class="ml-n2 mr-n2"
                >
                    <v-col
                        class="big-letter pl-2 pr-2"
                        cols="1"
                    >
                        {{ personality.letter }}
                    </v-col>
                    <v-col 
                        class="pl-2 pr-2"
                        cols="11"
                    >
                        <v-row class="ml-n2 mr-n2">
                            <v-col
                                v-for="personalityInfo in personality.users"
                                :key="personalityInfo.id"
                                class="pl-2 pr-2 pb-8"  
                                cols="12"
                                lg="6"
                            >
                            <div class="card-mini">
                                <personalities-card-mini
                                    @clickCard="clickCard"
                                    :id="personalityInfo.id"
                                    :full_name="personalityInfo.full_name"
                                    :job_title="personalityInfo.job_title"
                                    :job_title_of_main_workplace="personalityInfo.job_title_of_main_workplace"
                                    :profile_pic="personalityInfo.profile_pic"
                                    :is_hidden_info="personalityInfo.is_hidden_info"
                                />
                            </div>                             
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<style lang="scss" scoped>
.container {
    margin-top: 32px;
    margin-left: 104px;
    margin-right: 104px;

    @media screen and (max-width: 767px) {
        margin-left: 40px;
        margin-right: 40px;
        margin-top: 24px;
    }
}

.card-mini {
    cursor: pointer;
}

.all-personalities-page-content-subheader {
    text-align: left;
}

.v-col-12 {
    padding: 0;
}

.letters-and-region {
    display: flex;
    align-items: center;
    gap: 30px;
}

.letters {
    display: flex;
    justify-content: space-between;
    width: 75%;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #002866;

    div {
        cursor: pointer;
        
        &:hover {
            text-decoration: underline;
        }
    }
}

.personalities-section {
    margin-top: 64px;
}

.v-col {
    display: flex;
    justify-content: start;
}

.big-letter {
    font-weight: 600;
    font-size: 36px;
    line-height: 40px;
    color: #002866;
}

:deep(.v-label) {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #002866;
}
</style>
